<template>
    <main class="h-100">
        <div class="d-flex h-100">
            <component id="sidebar-left" :is="sidebar"></component>
            <div class="col h-100 px-0 overflow-hidden">
                <perfect-scrollbar id="scrollbar-main" class="pt-2 px-2">
                    <router-view />
                </perfect-scrollbar>
            </div>
        </div>
    </main>
</template>
<script>
    export default {
        computed:{
            sidebar() {
                let sidebar = this.$route.meta.sidebar;
                if (typeof this.$route.meta.sidebar == 'undefined') return false;
                return () => import(`@/components/Sidebars/${sidebar}.vue`);
            }
        }
    }
</script>